//
//
//
//
//
//
//
//
//
//

import getfetchImgMx from '@/common/mixin/getfetchImg.js'
import GAwesomeSwiper from '@/common/components/g-awesome-swiper/'
export default{
  mixins: [getfetchImgMx],
  props: {
    imgCode: {
      type: String,
      required: true
    },
    pagination: { // 是否有切换按钮
      type: Boolean,
      default: false
    },
    autoplay: { // 是否自动播放
      type: Boolean,
      default: true
    },
    slidesPerView: { // 视图中有几个图片
      type: Number,
      default: 1
    },
    centeredSlides: { // 一屏多个图片是否居中
      type: Boolean,
      default: false
    }
  },
  components: { GAwesomeSwiper },
  data() {
    return {
      imglist: []
    }
  },
  created() {
    this._getfetchImg(this.imgCode)
  },

  methods: {
    implementationFetched([data, res], imgCode) {
      this.$nextTick(() => {
        this.imglist = data
      })
    },

    handleClick(v) {
      if (!this.imglist[v]) return
      const links = this.imglist[v].imgClickLink
      if (links === '') return
      if (links.indexOf('http') !== -1) {
        window.open(links, '_blank')
      } else {
        if (this.$store.state.showLogin) this.$store.commit('SET_LOGIN_HIDE')
        if (this.$store.state.showRegister) this.$store.commit('SET_REGISTER', false)
        this.$router.replace({ path: links.replace('#', '') })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/components/links-banner/index.vue